import { Resolvers } from '@apollo/client/core';

import { OrderDetailed } from '../models/order-detailed';
import { OrderItemGrouping, OrderItem, FulFillmentMethods } from '../models/order-item';

export const OrderGroupedItemsResolver: Resolvers = {
  Order: {
    groupedItems: (parent: OrderDetailed): OrderItemGrouping[] => parent.items
      .filter(item => item.fulfillmentMethod !== FulFillmentMethods.storeInternal)
      .reduce((groupings: OrderItemGrouping[], item: OrderItem) => {
        const key = item.group ? item.group.name : item.name;
        const group = groupings.find(grp => grp.name === key);
        if (!group) {
          groupings.push({ name: key, items: [item], description: item.group ? item.group.description : '' });
        } else {
          group.items.push(item);
        }
        return groupings;
      }, []),
    internalItems(parent: OrderDetailed): OrderItem[] {
      return parent.items.filter(item => item.fulfillmentMethod === FulFillmentMethods.storeInternal);
    }
  }
};
